import { axiosJWTInstance } from "../../../utils/axiosJWTInstance";
import { Dispatch } from "redux";

import {
  GET_ORDERS_ATTEMPT,
  GET_ORDERS_SUCCESS,
  GET_ORDERS_FAILURE,
} from "../../constants";

// getOrders actions
const getOrdersAttempt = (payload: any) => ({
  type: GET_ORDERS_ATTEMPT,
  payload
});

const getOrdersSuccess = (payload: any) => ({
  type: GET_ORDERS_SUCCESS,
  payload,
});

const getOrdersFailure = (error: string) => ({
  type: GET_ORDERS_FAILURE,
  payload: {
    error,
  },
});

export const getOrdersRequest = (data: any, paramsToAdd: any, entity: string) => (dispatch: Dispatch) => {
  dispatch(getOrdersAttempt(data));

  const params2 = {
    entity: entity,
    ...paramsToAdd
  }

  const searchParams = new URLSearchParams(params2);
  const webUrl = `/Orders?${searchParams.toString()}`;

  return axiosJWTInstance
    .post(webUrl, data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "content-type": "application/json",
      }
    })
    .then((res) => res.data)
    .then((payload) => {
      dispatch(getOrdersSuccess(payload));
    })
    .catch((error) => {
      dispatch(getOrdersFailure(error.message));
    });
};
